import ChatProvider from '../store/schema/ChatProvider';
import { getStore } from '../store/chatStore';

export default function shouldUseUcma() {
    const chatProvider = getStore().chatProvider;

    // We are using UCMA for UCWA for now
    return chatProvider == ChatProvider.UCMA || chatProvider == ChatProvider.UCWA;
}
